import React from 'react';

export default function LoginButton({ onClick, loading }) {
  return (
    <button className="google-button" type="button" onClick={onClick} disabled={loading}>
      <span className="google-mark" aria-hidden="true">G</span>
      <span>{loading ? 'Signing in…' : 'Continue with Google'}</span>
    </button>
  );
}
